<template>
  <li
    class="nav-item cursor-pointer"
    @click="action"
    data-test-id="logout"
    data-test-class="nav-item"
  >
    <a class="nav-link" :class="classes" aria-current="page">
      <i class="c-sidebar-nav-icon fi flaticon-log-out"></i>{{ text }}</a
    >
  </li>
</template>
<script>
export default {
  props: ["classes", "text", "active", "href"],
  methods: {
    action() {
      this.$store.dispatch("authentication/logOut")
    }
  }
}
</script>
